export function getSlug(input: string, allowed: string[] = []): string {
  // Escape special regex characters in the allowed array
  const escapedAllowed = allowed
    .map((char) => {
      // List of regex special characters that need escaping
      const specialChars = /[.*+?^${}()|[\]\\]/;
      return specialChars.test(char) ? `\\${char}` : char;
    })
    .join("");

  // Build the regex pattern dynamically
  const pattern = new RegExp(`[^a-z0-9${escapedAllowed}]`, "g");

  return input
    .normalize("NFD") // Decompose characters
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritical marks
    .toLowerCase() // Convert to lowercase
    .replace(pattern, "-") // Replace non-alphanumeric characters with dashes, except allowed characters
    .replace(/--+/g, "-") // Remove consecutive dashes
    .replace(/^-+|-+$/g, ""); // Trim leading/trailing dashes
}
